<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="snackbars.errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericInfoSnackbar" color="primary">

      {{ snackbars.genericInfoText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericInfoSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericErrorSnackbar" color="error">

      {{ snackbars.genericErrorText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericErrorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-card elevation="0" class="pa-2">

      <v-card-title class="text-h5 word-break"><strong>Financials</strong></v-card-title>

      <v-card-text class="text-body-1">

        <p>To download transactions, please specify period:</p>

        <v-container class="ml-6 mr-4 mb-10 mt-6">

          <v-row>

            <v-col cols="12" md="4">

              <v-autocomplete label="Payment Method*" v-model="paymentMethod" :items="['Credit Card - Visa', 'Credit Card - Mastercard', 'Credit Card - Manual', 'Cheque', 'Cash']" outlined style="max-width: 400px" :error-messages="paymentMethodErrors"></v-autocomplete>

            </v-col>

            <v-col cols="12" md="2">

              <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                <template v-slot:activator="{ on, attrs }">

                  <v-text-field v-model="startDate" label="Start Date*" hint="MM/DD/YYYY" maxlength="10" :error-messages="startDateErrors" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="startDatePicker = parseDate(startDate)" v-on="on" outlined style="max-width: 175px"></v-text-field>

                </template>

                <v-date-picker v-model="startDatePicker" no-title @input="startDateMenu = false"></v-date-picker>

              </v-menu>

            </v-col>

            <v-col cols="12" md="6">

              <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                <template v-slot:activator="{ on, attrs }">

                  <v-text-field v-model="endDate" label="End Date*" hint="MM/DD/YYYY" maxlength="10" :error-messages="endDateErrors" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="endDatePicker = parseDate(endDate)" v-on="on" outlined style="max-width: 175px"></v-text-field>

                </template>

                <v-date-picker v-model="endDatePicker" no-title @input="endDateMenu = false"></v-date-picker>

              </v-menu>

            </v-col>

          </v-row>

        </v-container>

        <div style="text-align: right">

          <hr />

          <v-btn class="primary mt-4" @click="download"><v-icon left>mdi-download</v-icon>Download</v-btn>

        </div>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

import {required} from "vuelidate/lib/validators";

function validateDateFormat(value:string) {

  if (value == '') return true;

  const regex = /^\d{2}\/\d{2}\/\d{4}$/;

  return regex.test(value);
}

export default Vue.extend({

  name: 'Exceptions',

  validations: {

    paymentMethod: {

      required

    },

    startDate: {

      required,

      validateDateFormat

    },

    endDate: {

      required,

      validateDateFormat

    }

  },

  computed: {

    paymentMethodErrors()
    {
      if (!this.$v.$dirty) return [];

      if (this.$v.paymentMethod && !this.$v.paymentMethod.required)
      {
        return ['Payment Method is required.'];
      }

      return [];

    },

    startDateErrors()
    {
      if (!this.$v.$dirty) return [];

      if (this.$v && this.$v.startDate  && !this.$v.startDate.required)
      {
        return ['Start Date is required.'];
      }
      else if (this.$v && this.$v.startDate && !this.$v.startDate.validateDateFormat)
      {
        return ['Start Date is invalid.'];
      }

      return [];
    },

    endDateErrors()
    {
      if (!this.$v.$dirty) return [];

      if (this.$v && this.$v.endDate  && !this.$v.endDate.required)
      {
        return ['End Date is required.'];
      }
      else if (this.$v && this.$v.endDate && !this.$v.endDate.validateDateFormat)
      {
        return ['End Date is invalid.'];
      }

      return [];
    }

  },

  methods: {

    formatDate (date:any):any {

      if (!date) return null

      const [year, month, day] = date.split('-')

      return `${month}/${day}/${year}`

    },

    parseDate (date:any):any {

      if (!date) return null

      const [month, day, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

    },

    clearSnackbars(){

      this.snackbars.errorSnackbar = false;

      this.snackbars.genericInfoSnackbar = false;

      this.snackbars.genericErrorSnackbar = false;

    },

    download() {

      this.$v.$touch();

      if (this.$v.$error) {

        this.snackbars.errorSnackbar = true;

      } else {

        this.clearSnackbars();

        this.loading = true;

        setTimeout(async () => {

          try {

            var timePeriod = { startDate: this.startDate, endDate: this.endDate, paymentMethod: this.paymentMethod };

            let obj = { data: null as any };

            this.loading = false;

            if (obj.data == '%%INVALID_TIME_PERIOD%%') {

              this.snackbars.genericErrorText = 'The time period is invalid.  Please try again.';

              this.snackbars.genericErrorSnackbar = true;

              return;

            }

            let data = obj.data;

            let csvContent = "data:text/csv;charset=utf-8," + data;

            let encodedUri = encodeURI(csvContent);

            let link = document.createElement("a");

            link.setAttribute("href", encodedUri);

            link.setAttribute("download", "OBRS - Transactions.html");

            document.body.appendChild(link);

            link.click();

            this.snackbars.genericInfoText = 'The transactions have been successfully exported.'

            this.snackbars.genericInfoSnackbar = true;

          }
          catch (error:any)
          {
            // there was an exception

            if (error.response && error.response.status == 401) {

              // the exception is "Unauthorized", redirect to login screen

              if (this.$route.path != '/Login') this.$router.push('/Login');

            }
            else if (error.response && error.response.status == 404) {

              // the exception is "404 Not Found", redirect to 404 screen

              if (this.$route.path != '/NotFound') this.$router.push('/NotFound');

            }
            else {

              // all other exceptions

              this.clearSnackbars();

              this.snackbars.genericErrorText = 'There was an issue contacting the server.';

              this.snackbars.genericErrorSnackbar = true;

            }
          }

        }, 200)
      }
    }

  },

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

      }
      catch
      {
        if (this.$route.path != '/Login') this.$router.push('/Login');
      }

      this.loading = false;

    }, 200)

  },

  data () {

    return {

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

      },

      loading: false,

      paymentMethod: '',

      startDateMenu: false,

      startDatePicker: '',

      startDate: '',

      endDateMenu: false,

      endDatePicker: '',

      endDate: ''

    }

  },

  watch: {

    startDatePicker (val) {

      this.startDate = this.formatDate(this.startDatePicker)

    },

    endDatePicker (val) {

      this.endDate = this.formatDate(this.endDatePicker)

    }

  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

th > .v-icon {

  color: white !important;

}

th, td {

  font-size: 18px !important;

}

</style>
